import React from 'react';
import PropTypes from 'prop-types';

export default function TeacherSettlementStatus({ tone, children, compact, id }) {
  const icons = { success: 'check-circle', danger: 'exclamation-circle', warning: 'exclamation-triangle', muted: 'ban', info: 'clock' };
  return (
    <span id={id} className={`payroll-status payroll-status--${tone}${compact ? ' payroll-status--compact' : ''}`}>
      <i className={`fas fa-${icons[tone] || 'info-circle'}`} aria-hidden="true" />
      {children}
    </span>
  );
}
TeacherSettlementStatus.propTypes = { tone: PropTypes.string.isRequired, children: PropTypes.node.isRequired, compact: PropTypes.bool, id: PropTypes.string };
TeacherSettlementStatus.defaultProps = { compact: false, id: undefined };
